var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label",class:_vm.labelClass},[(_vm.icon)?_c('div',{staticClass:"icon-wrapper"},[_c('span',{staticClass:"icon",class:_vm.icon})]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }